<template>
  <div id="app">
    <header class="content-container">
      <div class="content-box">
        <div class="header-content">
          <router-link to="/" v-if="!isFrontPage()">
            <h1>
              <img src="./assets/stadtkatalog/stadtkatalog-logo-white.svg" alt="StadtKatalog" title="">
            </h1>
          </router-link>
          <div v-else>
            <h1>
              <img src="./assets/stadtkatalog/stadtkatalog-logo-white.svg" alt="StadtKatalog" title="">
            </h1>
          </div>
        </div>
      </div>
    </header>
    <main class="content-container">
      <div class="content-box">
        <router-view></router-view>
      </div>
    </main>
    <footer>
      <router-link to="/ueber">Impressum</router-link> | <router-link to="/datenschutz">Datenschutz</router-link><br>
      <a href="https://stadtkatalog.org">(CC BY 4.0) StadtKatalog.org</a><br><br>
      Datenquellen (CC BY 4.0):<br><a href="https://data.wien.gv.at">Stadt Wien</a> | Grundkarte von <a href="https://basemap.at">Basemap.at</a>
    </footer>
  </div>
</template>

<script>
import "normalize.css";

export default {
  name: "app",
  methods: {
    isFrontPage: function() {
      return this.$route.path === "/";
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/base.scss";
  @import "./assets/ionicons.css";
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style lang="scss" scoped>
  header {
    height: 4.75rem;
    background-color: #90a4ae;
  }

  .header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #ffffff;

    a {
      color: inherit;
      text-decoration: none;

      &.router-link-active:focus {
        color: #ffffff;
      }

      &.router-link-active:hover,
      &:hover,
      &:focus {
        color: #c0c0c0;
      }
    }

    h1 {
      img {
        width: auto;
        height: 100%;
      }

      flex: 1 1 auto;
      height: 3.25rem;
      margin: 0;
      padding: 0.3125rem 0 0 0;
    }
  }

  footer {
    font-size: 0.75rem;
    line-height: 1.125rem;
    margin-top: 5rem;
    text-align: center;
    color: #9f9f9f;

    a {
      color: #8d8d8d;
    }
  }

  @media (max-width: 50rem) {
    header {
      height: 4rem;
    }

    .header-content {
      padding: 0 10px;
      h1 {
        height: 3rem;
        font-size: 1.75rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/AppStadtKatalog.vue